$(document).on('change', 'select.skillWorkPlaces', function(){
    var _target = $(this);
    var _id_lloc = _target.val();
    var _id_centre = _target.closest('.parent').data('centre');

    _target.popover('dispose');

    if(_id_lloc && _id_centre) {
        $.post("/ajax/enterprise/getSkillworkplace", {'id_lloc': _id_lloc, 'id_centre' : _id_centre}, function (json) {
            if (json.success === true) {
                _target.popover({
                    'container': 'body',
                    'content': json.description,
                    'title': Lang.get('messages.description'),
                    'placement' : 'bottom'
                });
                _target.popover('show');
            }
        });
    }
});

$(document).on('click', '.overlay', function(){
    $('select.skillWorkPlaces').popover('hide');
});

//Filtratge de factures per concepte
$(document).on('change', '.invoice-filter', function(){
    let concept = $('#invoiceConceptFilter').find('option:selected').text();
    let conceptId = $('#invoiceConceptFilter').val();
    let yearText = $('#invoiceYearFilter').find('option:selected').text();
    let yearId = $('#invoiceYearFilter').val();

    console.log(concept, conceptId,  yearText, yearId);

    if(conceptId.length || yearId.length){
        $('#invoicesList').find('.topic').each(function(){
            $(this).toggle(
                ($(this).data('filter1').toString() === concept || (! conceptId.length)) &&
                ($(this).data('filter2').toString() === yearText || (!yearId))
            )
        });
    }else{
        $('#invoicesList').find('.topic').show();
    }
});

//Filtratge de pressupostos per codi
$(document).on('change', '.budget-filter', function(){
    let concept = $('#budgetConceptFilter').val();
    let yearText = $('#budgetYearFilter').find('option:selected').text();
    let yearId = $('#budgetYearFilter').val();

    console.log(concept, yearText, yearId);

    if(concept.length || yearId.length){
        $('#budgetsList').find('.topic').each(function(){
            $(this).toggle(
                ($(this).data('filter1').toString() === concept || (!concept.length)) &&
                ($(this).data('filter2').toString() === yearText || (!yearId))
            )
        });
    }else{
        $('#budgetsList').find('.topic').show();
    }
});

$(document).on('change', '#budgetFormUpload input:file', function(e){
    let file = this.files[0];
    let _data = new FormData();
    _data.append('file', file);
    _data.append('budget_id', $(e.target).data('budget'));

    $.ajax({
        url: '/ajax/enterprise/budgets/upload',
        type: 'POST',
        data: _data,
        contentType: false,
        processData: false,
        success: function(json){
            $.toast({
                text: json.message,
                icon: (json.success === true) ? 'success' : 'warning',
                position: 'bottom-right'
            });
            if(json.success === true){
                $('#budgetFormUpload small.gd').html(json.message);
            }
        }
    });
});

